import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EditTaxIdentityPopup from "./EditTaxIdentityPopup";

const AddTaxIdentityPopup = ({
    extendedProps: {
        saveTaxIdentity,
    },
    onCancelChanges,
    open,
}) => {
    const handleClose = useCallback(() => {
        onCancelChanges();
    }, [onCancelChanges]);

    return (
        <EditTaxIdentityPopup
            open={open}
            save={saveTaxIdentity}
            onClose={handleClose}
        />
    );
};

AddTaxIdentityPopup.propTypes = {
    extendedProps: PropTypes.shape({
        saveTaxIdentity: PropTypes.func.isRequired,
    }).isRequired,
    onCancelChanges: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default AddTaxIdentityPopup;